import Request from "../model/Request";
import Response from "../model/Response";
import {Config} from "../util/Config";
import PagedResponse from "../entities/PagedResponse";
import Pagination from "../entities/Pagination";
import BillingPeriod from "../entities/BillingPeriod";
import { RestClient } from "../util/RestClient";
import ChildAgencyBillingPeriodResponse from "../model/billingPeriod/ChildAgencyBillingPeriodResponse";

export module BillingPeriodService {
    export async function get(page: number = 1, pageSize: number = 15, filter?: string): Promise<Response<PagedResponse<BillingPeriod>>> {
        const url = Config.get("GET_BILLING_PERIODS_URL", {page, pageSize, filter});
        const request = new Request(url)
        const response = await RestClient.get(request)
        if (response.success) {
            const billingPeriodsData = response.data?.data;
            const paginationData = response.data?.pagination;
            if (billingPeriodsData && paginationData) {
                const data = billingPeriodsData.map((t: any) => new BillingPeriod(
                    t.id,
                    t.description,
                    t.startDate,
                    t.endDate,
                    t.status,
                    t.createdAt,
                ));
                const pagination = new Pagination(paginationData.currentPage, paginationData.pageSize, paginationData.elementsCount, paginationData.pageCount);
                return new Response<PagedResponse<BillingPeriod>>(true, {data, pagination}, response.error)
            }
        }
        return new Response<PagedResponse<BillingPeriod>>(false, undefined, response.error, response.status);
    }

    export async function find(id: string): Promise<Response<BillingPeriod>> {
        const url = Config.get("FIND_BILLING_PERIOD_URL", {id});
        const request = new Request(url)
        const response = await RestClient.get(request);
        if (response.success) {
            const t = response.data;
            if (t) {
                const billingPeriod = new BillingPeriod(
                    t.id,
                    t.description,
                    t.startDate,
                    t.endDate,
                    t.status,
                    t.createdAt,
                );
                return new Response<BillingPeriod>(true, billingPeriod, response.error);
            }
        }
        return new Response<BillingPeriod>(true, undefined, response.error, response.status);
    }

    export async function create(billingPeriod: BillingPeriod): Promise<Response<any>> {
        const url = Config.get("CREATE_BILLING_PERIOD_URL");
        const request = new Request(url, billingPeriod);
        return await RestClient.post(request);
    }

    export async function update(billingPeriod: BillingPeriod): Promise<Response<any>> {
        const url = Config.get("UPDATE_BILLING_PERIOD_URL", {id: billingPeriod.id});
        const request = new Request(url, billingPeriod);
        return await RestClient.put(request);
    }

    export async function remove(billingPeriod: BillingPeriod): Promise<Response<any>> {
        const url = Config.get("REMOVE_BILLING_PERIOD_URL", {id: billingPeriod.id});
        const request = new Request(url);
        return await RestClient.remove(request);
    }

    export async function close(billingPeriodId: string, notes?: string): Promise<Response<any>> {
        const url = Config.get("CLOSE_BILLING_PERIOD_URL", {id: billingPeriodId});
        const request = new Request(url, { notes });
        return await RestClient.post(request);
    }

    export async function bill(billingPeriodId: string): Promise<Response<any>> {
        const url = Config.get("BILL_BILLING_PERIOD_URL", {id: billingPeriodId});
        const request = new Request(url, {});
        return await RestClient.post(request);
    }

    export async function getChildAgencyBillingPeriod(page: number = 1, pageSize: number = 15, filter?: string): Promise<Response<PagedResponse<ChildAgencyBillingPeriodResponse>>> {
        const url = Config.get("GET_CHILD_AGENCY_BILLING_PERIODS_URL", {page, pageSize, filter});
        const request = new Request(url)
        const response = await RestClient.get(request)
        if (response.success) {
            const billingPeriodsData = response.data?.data;
            const paginationData = response.data?.pagination;
            if (billingPeriodsData && paginationData) {
                const data = billingPeriodsData.map((t: any) => new ChildAgencyBillingPeriodResponse(
                    t.id,
                    t.description,
                    t.startDate,
                    t.endDate,
                    t.status,
                    t.childAgencyAmount,
                ));
                const pagination = new Pagination(paginationData.currentPage, paginationData.pageSize, paginationData.elementsCount, paginationData.pageCount);
                return new Response<PagedResponse<ChildAgencyBillingPeriodResponse>>(true, {data, pagination}, response.error)
            }
        }
        return new Response<PagedResponse<ChildAgencyBillingPeriodResponse>>(false, undefined, response.error, response.status);
    }

}